var React = require('react');

function ArrowRoundedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M50 0H0V50H50V0Z","fill":"#F38D11","key":0}),React.createElement("path",{"d":"M39.0607 26.0607C39.6464 25.4749 39.6464 24.5251 39.0607 23.9393L29.5147 14.3934C28.9289 13.8076 27.9792 13.8076 27.3934 14.3934C26.8076 14.9792 26.8076 15.9289 27.3934 16.5147L35.8787 25L27.3934 33.4853C26.8076 34.0711 26.8076 35.0208 27.3934 35.6066C27.9792 36.1924 28.9289 36.1924 29.5147 35.6066L39.0607 26.0607ZM11 26.5L38 26.5L38 23.5L11 23.5L11 26.5Z","fill":"white","key":1})]);
}

ArrowRoundedInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = ArrowRoundedInline;

ArrowRoundedInline.default = ArrowRoundedInline;
